/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { documents_AttachFileRequest } from '../models/documents_AttachFileRequest';
import type { documents_CreateDocumentRequest } from '../models/documents_CreateDocumentRequest';
import type { documents_DocumentAcknowledgementResponse } from '../models/documents_DocumentAcknowledgementResponse';
import type { documents_DocumentDownloadResponse } from '../models/documents_DocumentDownloadResponse';
import type { documents_DocumentResponse } from '../models/documents_DocumentResponse';
import type { documents_DocumentVersionResponse } from '../models/documents_DocumentVersionResponse';
import type { documents_ListAccessLogsResponse } from '../models/documents_ListAccessLogsResponse';
import type { documents_ListDocumentsResponse } from '../models/documents_ListDocumentsResponse';
import type { documents_ListVersionsResponse } from '../models/documents_ListVersionsResponse';
import type { documents_ReplaceVersionRequest } from '../models/documents_ReplaceVersionRequest';
import type { documents_UpdateDocumentRequest } from '../models/documents_UpdateDocumentRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentsService {
    /**
     * List documents
     * Get paginated list of documents with optional filters
     * @param page Page number
     * @param pageSize Items per page
     * @param category Filter by category
     * @param confidentiality Filter by confidentiality
     * @param isPublished Filter by published status
     * @param displayTarget Filter by display target
     * @param search Search by name
     * @returns documents_ListDocumentsResponse OK
     * @throws ApiError
     */
    public static getApiV1Documents(
        page: number = 1,
        pageSize: number = 20,
        category?: string,
        confidentiality?: string,
        isPublished?: boolean,
        displayTarget?: string,
        search?: string,
    ): CancelablePromise<documents_ListDocumentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents',
            query: {
                'page': page,
                'page_size': pageSize,
                'category': category,
                'confidentiality': confidentiality,
                'is_published': isPublished,
                'display_target': displayTarget,
                'search': search,
            },
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list documents`,
            },
        });
    }
    /**
     * Create a new document
     * Create a new document record with metadata
     * @param request Document to create
     * @returns documents_DocumentResponse Created
     * @throws ApiError
     */
    public static postApiV1Documents(
        request: documents_CreateDocumentRequest,
    ): CancelablePromise<documents_DocumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/documents',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to create document`,
            },
        });
    }
    /**
     * Delete document
     * Soft delete a document
     * @param id Document ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Documents(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                500: `Failed to delete document`,
            },
        });
    }
    /**
     * Get document by ID
     * Get a single document by ID
     * @param id Document ID
     * @returns documents_DocumentResponse OK
     * @throws ApiError
     */
    public static getApiV1Documents1(
        id: string,
    ): CancelablePromise<documents_DocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                500: `Failed to get document`,
            },
        });
    }
    /**
     * Update document metadata
     * Update a document's metadata with optimistic locking
     * @param id Document ID
     * @param request Document metadata to update
     * @returns documents_DocumentResponse OK
     * @throws ApiError
     */
    public static putApiV1Documents(
        id: string,
        request: documents_UpdateDocumentRequest,
    ): CancelablePromise<documents_DocumentResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/documents/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                409: `Version conflict`,
                500: `Failed to update document`,
            },
        });
    }
    /**
     * List document access logs
     * Get paginated access logs for a document (admin only)
     * @param id Document ID
     * @param page Page number
     * @param pageSize Items per page
     * @returns documents_ListAccessLogsResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsAccessLogs(
        id: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<documents_ListAccessLogsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/{id}/access-logs',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                500: `Failed to list access logs`,
            },
        });
    }
    /**
     * Attach file to document
     * Link a confirmed uploaded file to a document
     * @param id Document ID
     * @param request File to attach
     * @returns documents_DocumentResponse OK
     * @throws ApiError
     */
    public static postApiV1DocumentsAttachFile(
        id: string,
        request: documents_AttachFileRequest,
    ): CancelablePromise<documents_DocumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/documents/{id}/attach-file',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or file not confirmed`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document or file not found`,
                500: `Failed to attach file`,
            },
        });
    }
    /**
     * Download a document (audited)
     * Issues a fresh presigned download URL for the document's current version and records a `download` access-log row. Staff surface; same gate as GET /api/v1/documents/{id}.
     * @param id Document ID
     * @returns documents_DocumentDownloadResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsDownload(
        id: string,
    ): CancelablePromise<documents_DocumentDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/{id}/download',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found or has no file`,
                500: `Failed to issue download URL`,
            },
        });
    }
    /**
     * List document versions
     * Get version history for a document
     * @param id Document ID
     * @param limit Items per page
     * @param offset Offset
     * @returns documents_ListVersionsResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsVersions(
        id: string,
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<documents_ListVersionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/{id}/versions',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                500: `Failed to list versions`,
            },
        });
    }
    /**
     * Replace document with new version
     * Upload a new version of the document, preserving the old version in history
     * @param id Document ID
     * @param request New version details
     * @returns documents_DocumentResponse OK
     * @throws ApiError
     */
    public static postApiV1DocumentsVersions(
        id: string,
        request: documents_ReplaceVersionRequest,
    ): CancelablePromise<documents_DocumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/documents/{id}/versions',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or file not confirmed`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document or file not found`,
                500: `Failed to replace version`,
            },
        });
    }
    /**
     * Get specific document version
     * Get a specific version of a document with download URL
     * @param id Document ID
     * @param versionNumber Version number
     * @returns documents_DocumentVersionResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsVersions1(
        id: string,
        versionNumber: number,
    ): CancelablePromise<documents_DocumentVersionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/{id}/versions/{versionNumber}',
            path: {
                'id': id,
                'versionNumber': versionNumber,
            },
            errors: {
                400: `Invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Version not found`,
                500: `Failed to get version`,
            },
        });
    }
    /**
     * List published documents
     * Get published documents for a display target. Role-based enforcement: parents can only query parent_app, employees can query employee_app or parent_app, admins can query any target.
     * @param target Display target (parent_app, employee_app)
     * @param category Filter by category
     * @param search Search by name
     * @param page Page number
     * @param pageSize Items per page
     * @returns documents_ListDocumentsResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsPublished(
        target: string,
        category?: string,
        search?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<documents_ListDocumentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/published',
            query: {
                'target': target,
                'category': category,
                'search': search,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                400: `Missing target parameter`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Not found`,
                500: `Failed to list published documents`,
            },
        });
    }
    /**
     * Get published document
     * Get a published document with download URL (records access log). Role-based enforcement: the document's display_targets must include a target the user's role is allowed to see.
     * @param id Document ID
     * @returns documents_DocumentResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsPublished1(
        id: string,
    ): CancelablePromise<documents_DocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/published/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                500: `Failed to get published document`,
            },
        });
    }
    /**
     * Confirm a published document as read and accepted
     * Records the calling parent's "Read and accepted" for the document's current version and returns when it was first confirmed. Idempotent: a repeated confirmation returns the stored first timestamp. Only a document published to the parent app can be confirmed; a newer version is unconfirmed again. Parents only.
     * @param id Document ID
     * @returns documents_DocumentAcknowledgementResponse OK
     * @throws ApiError
     */
    public static postApiV1DocumentsPublishedAcknowledge(
        id: string,
    ): CancelablePromise<documents_DocumentAcknowledgementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/documents/published/{id}/acknowledge',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid document id`,
                401: `Authentication required`,
                403: `Not a resolved parent`,
                404: `Document not found`,
                500: `Failed to confirm document`,
            },
        });
    }
    /**
     * Download a published document (audited)
     * Issues a fresh presigned download URL for a published document and records a `download` access-log row. Repeats the display-target authorization of GET /api/v1/documents/published/{id} in full, because this route is independently reachable.
     * @param id Document ID
     * @returns documents_DocumentDownloadResponse OK
     * @throws ApiError
     */
    public static getApiV1DocumentsPublishedDownload(
        id: string,
    ): CancelablePromise<documents_DocumentDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/documents/published/{id}/download',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing document id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Document not found`,
                500: `Failed to issue download URL`,
            },
        });
    }
}
